import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Sidebar";
import { Footer } from "./Header";

export function MainLayout() {
  const location = useLocation();
  
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16">
        <div 
          key={location.pathname}
          className="animate-fade-in"
          style={{ animationDuration: '0.2s' }}
        >
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
